import { AboutUsCard, AboutUsWrapper, Num } from "./AboutUsStyles";

function AboutUsComponents() {
  return (
    <AboutUsWrapper>
      <AboutUsCard>
        <Num>1</Num>
        <div>
          <h2><span>BTU AI</span> მისია და ხედვა</h2>
          <p>შევთავაზოთ საზოგადოებას უნიკალური გამოცდილება ბიზნესისა და საინფორმაციო ტექნოლოგიების სფეროებში მისი მოლოდინების შესატყვისი თანამედროვე უმაღლესი განათლება, განვავითაროთ პიროვნების ლიდერული და სამეწარმეო უნარ-ჩვევები, სამეწარმეო ეკოსისტემის შექმნისა და ბიზნესის მაღალ ტექნოლოგიებთან ინტეგრირების გზით მივცეთ არა მხოლოდ ლოკალურ, არამედ საერთაშორისო ბაზარზეც კონკურენტუნარიანობის მოტივაცია და შესაძლებლობა. სამეცნიერო კვლევების შედეგების, იდეებისა და ინოვაციების გაცვლით მოვახდინოთ ჩვენი პოტენციალის დემონსტრირება გლობალურ ბაზრებზე, ვიყოთ ორიენტირებულნი თანამედროვე ცოდნის შექმნაზე და გავრცელებაზე, საერთაშორისო სივრცეში ინტეგრირებაზე და საქართველოს სოციალურ-ეკონომიკური განვითარების ხელშეწყობაზე.უნივერსიტეტის მიზანი</p>
        </div>
      </AboutUsCard>

      <AboutUsCard>
        <Num>2</Num>
        <div>
          <h2><span>BTU AI</span> ისტორია</h2>
          <p>ბიზნესისა და ტექნოლოგიების უნივერსიტეტს მნიშვნელოვანი წვლილი შეაქვს ქვეყანაში ხელოვნური ინტელექტის პოტენციალის ათვისებისა და წიგნიერების გავრცელებაში.
          BTU-ში მოქმედებს ხელოვნური ინტელექტის ლაბორატორია, რომელიც 2018 წელს დაარსდა, მოქმედებს ხელოვნური ინტელექტის 2 პროგრამა, სადოქტორო და საბაკალავრო საფეხურზე. უნივერსიტეტის ბაზაზე იმართება უმსხვილესი კონკურსები და ჰაკათონები AI სფეროში, ასევე მიმდინარეობს მნიშვნელოვანი პროექტები, საერთაშორისო ორგანიზაციების მხარდაჭერით. </p>
        </div>
      </AboutUsCard>

      <AboutUsCard>
        <Num>3</Num>
        <div>
          <h2><span>BTU AI</span> საერთაშორისო პარტნიორები და თანამშრომლობა</h2>
          <p>AI4Globe ახალი, საერთაშორისო ინიციატივაა, რომელიც გლობალურად, ხელოვნური ინტელექტის წიგნიერების ზრდას ისახავს მიზნად. პროექტი მნიშვნელოვანწილად ცვლის საგანმანათლებლო გამოცდილებას და ქმნის ხელოვნური ინტელექტის პოტენციალის რეალიზების ახალ შესაძლებლობებს.
          უნიკალური და ყოვლისმომცველი საგანმანათლებლო აქტივობებით, საერთაშორისო პარტნიორებით, მულტიმედია და სხვა რესურსებით, ხელმისაწვდომი გახდება ფართო საზოგადოებისთვის, მათ შორის, ბავშვებისთვის, ახალგაზრდებისა და ქალებისთვის და ინტეგრირდება აკადემიურ სივრცესა და კერძო სექტორში.
          პროექტი პირველ ეტაპზე საქართველოში განხორციელდება, შემდგომში კი გაზიარდება და გავრცელდება საერთაშორისო სივრცეში.
          AI4GLOBE – ის 4 მიზნობრივი ჯგუფია:
        </p>
        </div>
      </AboutUsCard>
    </AboutUsWrapper>
  );
}

export default AboutUsComponents;
